import { clearMap } from './clear-map';

export function resetMap(map: google.maps.Map): void {
  map.fitBounds({ north: 85, south: -85, west: -180, east: 180 });
  clearMap(map);
}

export default resetMap;
